module.exports = __webpack_public_path__ + "img/8.88724496.png";